import React from 'react';
import {
    Box,
    Skeleton,
    SimpleGrid,
    HStack,
    Center,
  } from "@chakra-ui/react";
  
  const AppointmentTimeSkeleton = () => {
    return (
      <Box p={5} w="100%" maxW="800px" mx="auto">
        
  
        {/* Calendar Navigation Buttons */}
        <HStack justifyContent="space-between" mb={4}>
          <Skeleton height="32px" width="60px" borderRadius="full" />
          <Skeleton height="32px" width="60px" borderRadius="full" />
        </HStack>
  
        {/* Time Grid Skeleton */}
        <SimpleGrid columns={7} spacing={2}>
          {[...Array(7)].map((_, i) => (
            <Skeleton key={`day-header-${i}`} height="30px" />
          ))}
          {[...Array(35)].map((_, i) => (
            <Skeleton key={`slot-${i}`} height="40px" />
          ))}
        </SimpleGrid>
  
        {/* More Button Skeleton */}
        <Center mt={6}>
          <Skeleton height="32px" width="80px" borderRadius="full" />
        </Center>
      </Box>
    );
  };
  
  export default AppointmentTimeSkeleton;
  